import { render, staticRenderFns } from "./DetailedView.vue?vue&type=template&id=3e50ed6c&"
import script from "./DetailedView.vue?vue&type=script&lang=js&"
export * from "./DetailedView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports